import { useEffect, useState } from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Save, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { useAuth } from '../../contexts/AuthContext';

const STATUSES = ['Lost Lead', 'Junk Lead', 'Invalid No.', 'Not Contacted', 'Competitor', 'Location Issue', 'Other Course', 'Duplicate Lead', 'Archive'];

export const CbtSettings = ({ initial, onSaved }) => {
  const { user } = useAuth();
  const admin = user?.role === 'admin';
  const [s, setS] = useState(initial || null);
  useEffect(() => { if (!initial) api.get('/callback-tracker/report', { params: { period: 'today' } }).then(r => setS(cur => cur || r.data.settings)); }, [initial]);
  if (!s) return <div className="py-16 text-center text-slate-400"><Loader2 className="w-5 h-5 animate-spin inline" /></div>;
  const toggle = v => setS({ ...s, lost_statuses: s.lost_statuses.includes(v) ? s.lost_statuses.filter(x => x !== v) : [...s.lost_statuses, v] });
  const save = async () => {
    try { setS(await api.put('/callback-tracker/settings', s).then(r => r.data)); toast.success('Rules saved'); onSaved(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Save failed'); }
  };
  return (
    <Card className="p-4 max-w-xl space-y-4" data-testid="cbt-settings-tab">
      <h3 className="text-sm font-bold text-slate-900">Follow-up rules</h3>
      <label className="block text-xs text-slate-600">Going cold after this many days without a call
        <Input type="number" min="1" value={s.cold_days} disabled={!admin} onChange={e => setS({ ...s, cold_days: e.target.value })} className="h-8 w-24 text-xs mt-1" data-testid="cbt-cold-days-input" /></label>
      <label className="block text-xs text-slate-600">Minimum calls before a Call Back lead can be marked Lost
        <Input type="number" min="1" value={s.min_attempts} disabled={!admin} onChange={e => setS({ ...s, min_attempts: e.target.value })} className="h-8 w-24 text-xs mt-1" data-testid="cbt-min-attempts-input" /></label>
      <div className="text-xs text-slate-600">Lead statuses that count as Lost
        <div className="flex flex-wrap gap-1.5 mt-1.5">
          {STATUSES.map(v => (
            <button key={v} disabled={!admin} onClick={() => toggle(v)} data-testid={`cbt-lost-status-${v.replace(/[^a-zA-Z]/g, '-')}`}
              className={`px-2 py-1 rounded-full border ${s.lost_statuses.includes(v) ? 'bg-slate-900 text-white border-slate-900' : 'border-slate-200 text-slate-600'}`}>{v}</button>
          ))}
        </div>
      </div>
      <ul className="text-[11px] text-slate-500 list-disc pl-4 space-y-0.5">
        <li>Only calls logged in Zoho CRM count (the mobile app logs them automatically). Missed calls are not counted.</li>
        <li>A call counts for the user who made it; cold / never called are shown against the lead owner.</li>
        <li>A lead never called is cold {s.cold_days} days after it moved to Call Back. Calls are kept for the last 90 days.</li>
        <li>Bell: 9 AM cold-lead alert and 11:59 PM daily summary to admins and managers.</li>
      </ul>
      {admin ? <Button size="sm" onClick={save} data-testid="cbt-save-rules-btn"><Save className="w-3.5 h-3.5 mr-1.5" />Save rules</Button>
        : <p className="text-[11px] text-slate-400">Only an admin can change these rules.</p>}
    </Card>
  );
};
